// extracted by mini-css-extract-plugin
export default {"contentPageReduce":"adminspace_contentPageReduce__LwVyJ","contentPageFull":"adminspace_contentPageFull__i2Pzc"};